import { Pipe, PipeTransform } from '@angular/core';
import { MenuCategory, MenuCategoryWithUrl } from '@shared/models';

@Pipe({ name: 'menuHasUrl', standalone: true })
export class MenuHasUrlPipe implements PipeTransform {
  transform(value: MenuCategory): value is MenuCategoryWithUrl {
    return 'url' in value;
  }
}
